import React from "react";


export const localeStringFadeStyle: React.CSSProperties = {
    animation: "fadeIn 0.5s ease-in-out",
    opacity: 1,
};

// Inline CSS for fade keyframes
const fadeKeyframes = `
@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
`;

// Inject keyframes once into the DOM
export const localeStringInjectKeyFrames = () => {
    const existing = document.getElementById("fade-keyframes");
    if (!existing) {
        const style = document.createElement("style");
        style.id = "fade-keyframes";
        style.innerHTML = fadeKeyframes;
        document.head.appendChild(style);
    }
};
